import { Form, Analytics } from 'tortilla';

export default {
  data () {
    return {
      form: new Form(Tortilla.Xhr),
      showForm: true,
      successMessage: '',
      analytics: false,
      ga: null,
      clicky: null,

      clickyOptions: {
        name: 'Form Submission',
        goal: null,
        email: ''
      },

      // attributes that persist to the component after a form is
      // submitted
      persistents: { utm_source: null, utm_medium: null, utm_campaign: null },
      fields: {}
    };
  },

  computed: {
    errors() {
      return this.$validator.errors;
    },
    formErrors () {
      return this.form.errors.bag;
    },

    errorMessage () {
      if (this.form.errors.has('message')) {
        return this.form.errors.first('message');
      }

      return this.form.errors.first('_global');
    }
  },

  watchers: {
    formErrors (messages) {
      this.$validator.errors.clear();
      for (const [key, message] of Object.entries(messages)) {
        this.$validator.errors.add({ field: key, msg: message[0] });
      }
    }
  },

  methods: {
    boot () {
      this.$eventsBus.$on('ready', () => {
        try {
          this.ga = new Analytics.GoogleAnalytics();
        } catch (error) {
          console.error(error);
        }

        try {
          this.clicky = new Analytics.ClickyAnalytics();
        } catch (error) {
          console.error(error);
        }
      });
    },

    toggleForm () {
      this.showForm ^= 1;
    },

    success (response, event) {
      // this.successMessage = this.form.success.first('message');
      this.successMessage = response.data.message;
      this.reset();
      this.toggleForm();
      this.form.errors.empty();

      this.loadPseudoConfirmation(response, event);

      this.fireAnalytics(event);

      this.next(response);
    },

    fireAnalytics (event) {
      const uri = event.target.action;

      if (!(uri || this.analytics)) {
        return;
      }

      if (this.ga) {
        this.ga.sendGoal(uri);
      }

      if (this.clicky) {
        this.clicky.sendGoal(
          uri,
          this.clickyOptions.name,
          this.clickyOptions.goal,
          this.clickyOptions.email || ''
        );
      }
    },

    reset () {
      this.fields = {};
      this.$validator.errors.clear();
    },

    failure () {
      this.toggleForm();
    },

    async beforeSubmit () {
      this.successMessage = '';
      this.toggleForm();

      this.persistents.utm_source = localStorage.getItem('utmSource');
      this.persistents.utm_medium = localStorage.getItem('utmMedium');
      this.persistents.utm_campaign = localStorage.getItem('utmCampaign');
      this.persistents.utm_content = localStorage.getItem('utmContent');

      this.persistents.gclid = localStorage.getItem('seGclid');
      this.persistents.wbraid = localStorage.getItem('seWbraid');
      this.persistents.gbraid = localStorage.getItem('seGbraid');

      const tokenPromise = new Promise((resolve, reject) => {
        grecaptcha.enterprise.ready(() => {
          resolve(grecaptcha.enterprise.execute('6LeN4OIqAAAAAERBNyCJRdLamOl0LlwnlhecjMfF', {
            action: 'submit'
          }));
        });
      });

      return tokenPromise;
    },

    next (response) {
      if (typeof response === 'undefined') {
        return null;
      }

      if ('redirectTo' in response.data) {
        window.location = response.data.redirectTo;
      }
    },

    loadPseudoConfirmation (response, event) {
      // create a hidden iframe element and set its source
      const iframe = document.createElement('iframe');

      iframe.style.display = 'none';
      iframe.src = event.target.dataset.confirmation || '/forms/pseudo-confirmation';
      iframe.referrerPolicy = 'same-origin';

      document.body.appendChild(iframe);
    }
  }
};



// WEBPACK FOOTER //
// ./resources/components/forms/base-form.js